import { render, staticRenderFns } from "./video-uploader.vue?vue&type=template&id=291556a5&scoped=true"
import script from "./video-uploader.vue?vue&type=script&lang=js"
export * from "./video-uploader.vue?vue&type=script&lang=js"
import style0 from "./video-uploader.vue?vue&type=style&index=0&id=291556a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291556a5",
  null
  
)

export default component.exports